// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// **Utils Imports
import { CHALLENGES_FILTERS } from '../../../utils/constant'

export const challengeSlice = createSlice({
  name: 'workspace',
  initialState: {
    selectedChallenge: {},
    challangesTableFilters: { ...CHALLENGES_FILTERS },
    customTags: []
  },
  reducers: {
    setSelectedChalllenge(state, action) {
      state.selectedChallenge[action.payload.key] = action.payload.value
    },
    setChallengeTableFilters(state, action) {
      state.challangesTableFilters = action.payload
    },
    resetChallengeTableFilters(state) {
      state.challangesTableFilters = { ...CHALLENGES_FILTERS }
    },
    setCustomTags(state, action) {
      state.customTags = action.payload
    },
    resetCustomTags(state) {
      state.customTags = []
    }
  }
})

export const {
  setSelectedChalllenge,
  setChallengeTableFilters,
  resetChallengeTableFilters,
  setCustomTags,
  resetCustomTags
} = challengeSlice.actions

export default challengeSlice.reducer
